import React from 'react'
import MediaPermissionsSheet from './MediaPermissionsSheet'

/**
 * AskCameraMicPermissionsDialog
 * 
 * A wrapper component that provides camera and microphone permission requests
 * using the new MediaPermissionsSheet for a better mobile-first UX.
 * 
 * The new design features:
 * - Clear, compelling messaging for therapy/consultation users
 * - Platform-specific recovery guidance if permissions are blocked
 * - Mobile-optimized bottom sheet UI
 * - Trust indicators to encourage users to allow permissions
 */
export default function AskCameraMicPermissionsDialog({
  giveBothPermissionsDialogOpen,
  setGiveBothPermissionsDialogOpen,
  giveMicrophonePermissionDialogOpen,
  setGiveMicrophonePermissionDialogOpen,
  giveCameraPermissionDialogOpen,
  setGiveCameraPermissionDialogOpen,
  setMicrophoneError,
  setCameraError,
  setAvailableMicrophones,
  setSelectedMicrophone,
  setAvailableSpeakers,
  setSelectedSpeaker,
  setAvailableCameras,
  setSelectedCamera,
  sessionType = 'consultation', // 'consultation', 'therapy', 'session'
  onPermissionsGranted, // Optional callback when permissions are granted
  onSkipPermissions, // Optional callback when user chooses to skip permissions
}) {
  // Determine if any permission dialog should be open
  const isOpen = giveBothPermissionsDialogOpen || 
                 giveMicrophonePermissionDialogOpen || 
                 giveCameraPermissionDialogOpen

  const handleClose = () => {
    setGiveBothPermissionsDialogOpen(false)
    setGiveMicrophonePermissionDialogOpen(false)
    setGiveCameraPermissionDialogOpen(false)
  }

  const handlePermissionsGranted = () => {
    // Debug logging removed to prevent continuous logging loops
    onPermissionsGranted?.()
  }

  const handleSkipPermissions = () => {
    // Debug logging removed to prevent continuous logging loops
    handleClose()
    onSkipPermissions?.()
  }

  return (
    <MediaPermissionsSheet
      open={isOpen}
      onClose={handleClose}
      onPermissionsGranted={handlePermissionsGranted}
      onSkipPermissions={handleSkipPermissions}
      setMicrophoneError={setMicrophoneError}
      setCameraError={setCameraError}
      setAvailableMicrophones={setAvailableMicrophones}
      setSelectedMicrophone={setSelectedMicrophone}
      setAvailableSpeakers={setAvailableSpeakers}
      setSelectedSpeaker={setSelectedSpeaker}
      setAvailableCameras={setAvailableCameras}
      setSelectedCamera={setSelectedCamera}
      sessionType={sessionType}
    />
  )
}
